<template>
  <pricing-form
    :requiredFilters="requiredFilters"
    showDiscount
    :priority="priority"
    :moduleSlug="moduleSlug"
    formName="promotional-pricing"
  />
</template>

<script>
import { mapMutations, mapActions } from "vuex";
import PricingForm from "./PricingForm.vue";
import config from "../../../../config";

const { formPriority } = config;

export default {
  name: "PromotionalPricing",
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Promotional Pricing",
  },
  data() {
    return {
      requiredFilters: [
        "vendorFilter",
        "categoryFilter",
        "productTagFilter",
        "vendorModelFilter",
        "skuFilter",
      ],
      priority: formPriority["promotional-pricing"],
      moduleSlug: "promotional-pricing",
    };
  },
  components: { PricingForm },
  beforeDestroy() {
    this.resetFormState();
    this.pricingSetItem({ resource: "pricingManagerId", payload: 0 });
    this.pricingSetItem({ resource: "mode", payload: "" });
    this.pricingSetItem({ resource: "preFilledData", payload: null });
  },
  methods: {
    ...mapMutations("pricingManager", {
      pricingSetItem: "setItem",
    }),
    ...mapActions(["resetFormState"]),
  },
};
</script>
